
import { routes } from '../config/api_routes'

export const supplierService = {

    getSupplierList: (formData) => {
        return window.axios.post(routes.getSupllierListApi, formData)
    },
    getProductList:  (formData) => {
        return window.axios.post(routes.getSupplierProductListApi, formData)
    },
    
    addproductBrand: (formData) => {
        return window.axios.post(routes.addproductBrandApi, formData)
    },
    
    getSupplierById: (formData) => {
        return window.axios.post(routes.getSupplierByIdApi, formData)
    },
    
    editproductBrand: (formData) => {
        return window.axios.post(routes.editproductBrandApi, formData)
    },
    
    deleteProductBrand: (formData) => {
        return window.axios.post(routes.deleteProductBrandApi, formData)
    },


    // add Supplier

    addSupplier: (formData) => {
        return window.axios.post(routes.addSupplierApi, formData)
    },

    getProducerCompany: (formData) => {
        return window.axios.post(routes.getProducerCompanyNameApi, formData)
    },

    // getProducerCompanyById: (formData) => {
    //     return window.axios.post(routes.getProducerCompanyByIdApi, formData)
    // },
    
    editSupplier: (formData) => {
        return window.axios.post(routes.editSupplierApi, formData)
    },
    
    deleteSupplier: (formData) => {
        return window.axios.post(routes.deleteSupplierApi, formData)
    },


    // Producer Brand
    getAllProductByNameApi: (formData) => {
        return window.axios.post(routes.getAllSupplierProductByNameApi, formData)
    },

    getSubProductApi: (formData) => {
        return window.axios.post(routes.getSubProductTaxApi, formData)
    },
}